<template>
    <default-item class="new_years_food_item--container" :item="item" :pricing-types="pricingTypes"
                  :layout="priceLayout"></default-item>
</template>

<script lang="ts">
/**
 * Custom component for New Years food items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 0.0.1
 * @copyright  Copyright (C) 2024-2026, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2024-12-09 (1.0.0) (jhoward)
 *      - <thanksgivingFoodItem> copied to <newYearsFoodItem>.
 *
 *    2025-04-08 (1.0.1) (jhoward)
 *      - Remove "visual_" prefix from class names in <thanksgivingFoodItem>.
 *
 *    2025-12-03 (1.0.2) (jhoward)
 *      - Adjust visual styles in <newYearsFoodItem>.
 * @changelog
 *
 * 2026-07-20 (0.0.1) (jhoward)
 *   - Update App\Library\Js\Components\Menu\Item\NewYears_foodItem.vue to adjust visual styles for menu item title and description.
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'new-years-food-item',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    priceLayout: {
      type: String as PropType<'price-inline' | 'price-below'>,
      default: 'price-inline'
    }
  },
})
</script>

<style scoped>
.new_years_food_item--container {
  text-align: center;
}

.new_years_food_item--container:deep(.menu--item_title) {
  color: #9a7326;
  font-weight: normal;
}

.new_years_food_item--container:deep(.menu--item_description p:not(.menu--highlight)) {
  font-weight: lighter;
}

.new_years_food_item--container:deep(.menu--item_description p:first-child) {
  margin-top: 0;
}

.new_years_food_item--container.menu--item:not(.menu--item-multi_line_price) {
  line-height: 1em;
}

.menu--item:deep(.menu--item_description) {
  margin-top: 0;
}

.new_years_food_item--container:deep(.menu--tag) {
  right: -1em;
  margin: 0;
  font-size: 3.5em;
}
</style>